<mat-horizontal-stepper [linear]="true" #stepper>
  <mat-step userAForm [stepControl]="userAForm">
    <form [formGroup]="userAForm" class="w-full">
      <ng-template matStepLabel> {{ "ORGANIZATIONS" | translate }}</ng-template>
      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label>{{ "ORG_NAME" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="org_name" />
            <mat-error *ngIf="userAForm.get('org_name')?.hasError('required')">
              {{ "ORG_NAME_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="half-width" *ngIf="organizationId">
          <mat-label>Company Code</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="uniquecode" readonly />
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>{{ "ORG_TYPE" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <mat-select formControlName="org_type" required>
              <mat-option value="cooperative">Cooperative (Co-op)</mat-option>
              <mat-option value="corporation">Corporation</mat-option>
              <mat-option value="franchise">Franchise</mat-option>
              <mat-option value="government_organization">Government Organization</mat-option>
              <mat-option value="joint_venture">Joint Venture</mat-option>
              <mat-option value="opc">One Person Company (OPC)</mat-option>
              <mat-option value="partnership">Partnership</mat-option>
              <mat-option value="private_limited">Private Limited Company (Pvt Ltd)</mat-option>
              <mat-option value="psu">Public Sector Undertaking (PSU)</mat-option>
              <mat-option value="public_limited">Public Limited Company (Ltd)</mat-option>
              <mat-option value="sole_proprietorship">Sole Proprietorship</mat-option>
              <mat-option value="trust">Trust</mat-option>
            </mat-select>
            <mat-error *ngIf="userAForm.get('org_type')?.hasError('required')">
              {{ "ORG_TYPE_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="flex flex-row gap-4">
        <!-- Domain -->
        <div class="half-width">
          <mat-label>{{ "DOMAIN" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="full-width">
            <mat-select formControlName="domain" [multiple]="true" required>
              <mat-option value="Commercial">Commercial</mat-option>
              <mat-option value="Education">Education</mat-option>
              <mat-option value="Electric">Electric</mat-option>
              <mat-option value="Gas">Gas</mat-option>
              <mat-option value="Residential">Residential</mat-option>
              <mat-option value="Road">Road</mat-option>
              <mat-option value="Telecom">Telecom</mat-option>
              <mat-option value="Water">Water</mat-option>
            </mat-select>
            <mat-error *ngIf="userAForm.get('domain')?.hasError('required')">
              {{ "DOMAIN_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="half-width">
          <mat-label>{{ "REG_NO" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="registration_number" />
            <mat-error *ngIf="userAForm.get('registration_number')?.hasError('required')">
              {{ "CIN_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label>{{ "GST_NO" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="gst_number" />
            <mat-error *ngIf="userAForm.get('gst_number')?.hasError('required')">
              {{ "GST_REQUIRED" | translate }}
            </mat-error>
            <mat-error *ngIf="userAForm.get('gst_number')?.hasError('pattern')">
              {{ "GST_PATTERN_INVALID" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>{{ "PAN" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="pan_number" />
            <mat-error *ngIf="userAForm.get('pan_number')?.hasError('required')">
              {{ "PAN_REQUIRED" | translate }}
            </mat-error>
            <mat-error *ngIf="userAForm.get('pan_number')?.hasError('pattern')">
              {{ "PAN_PATTERN_INVALID" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label> {{ "Street" | translate }}</mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="street" />
            <mat-error *ngIf="userAForm.get('street')?.hasError('required')">
              {{ "employee.address" | translate }} {{ "REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label> {{ "employee.address" | translate }}</mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="address" />
            <mat-error *ngIf="userAForm.get('address')?.hasError('required')">
              {{ "employee.address" | translate }} {{ "REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label>{{ "COUNTRY" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <mat-select formControlName="country" (selectionChange)="onCountryChange()" required>
              <mat-option value="">{{
                "SELECT_COUNTRY" | translate
                }}</mat-option>
              <mat-option value="India">India</mat-option>
            </mat-select>
            <mat-error *ngIf="userAForm.get('country')?.hasError('required')">
              {{ "COUNTRY_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>{{ "STATE" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <mat-select formControlName="state" (selectionChange)="onStateChange()" required>
              <mat-option value="">{{ "SELECT_STATE" | translate }}</mat-option>

              <mat-option *ngFor="let state of states" [value]="state">{{
                state
                }}</mat-option>
            </mat-select>
            <mat-error *ngIf="userAForm.get('state')?.hasError('required')">
              {{ "STATE_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label>{{ "CITY" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <mat-select formControlName="city" required>
              <mat-option value="">{{ "SELECT_CITY" | translate }}</mat-option>
              <mat-option *ngFor="let city of cities" [value]="city">{{
                city
                }}</mat-option>
            </mat-select>
            <mat-error *ngIf="userAForm.get('city')?.hasError('required')">
              {{ "CITY_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>{{ "POSTAL_CODE" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="postal_code" />
            <mat-error *ngIf="userAForm.get('postal_code')?.hasError('required')">
              {{ "PINCODE_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="flex items-center gap-6 flex-wrap" style="margin-bottom: 5px">
        <div class="flex flex-col gap-2">
          <mat-label> {{ "UPLOAD_LOGO" | translate }}</mat-label>
          <button mat-raised-button color="primary" (click)="fileInput.click()">
            {{ "chooseLogo" | translate }}
          </button>
          <input type="file" accept="image/*" hidden #fileInput (change)="onFileSelected($event)" />
        </div>

        <div *ngIf="imagePreview" class="rounded border border-gray-300 p-2">
          <img src="{{ imagePreview }}" alt="Preview" class="max-w-[200px] max-h-[150px] object-contain" />
        </div>
      </div>

      <div class="form-actions">
        <button mat-raised-button color="primary" matStepperNext [disabled]="!userAForm.valid">
          {{ "NEXT" | translate }}
        </button>
      </div>
    </form>
  </mat-step>

  <mat-step userBForm [stepControl]="userBForm">
    <form [formGroup]="userBForm">
      <ng-template matStepLabel>{{
        "PRIMARY_CONTACT" | translate
        }}</ng-template>
      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label>Company Name</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="companyName" required />
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>Company ID</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="companyId" />
          </mat-form-field>
        </div>
      </div>
      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label>{{ "NAME" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="primary_contact_name" required />
            <mat-error *ngIf="
                userBForm.get('primary_contact_name')?.hasError('required')
              ">
              {{ "NAME_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="half-width">
          <mat-label>{{ "EMAIL" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="primary_contact_email" required />
            <mat-error *ngIf="
                userBForm.get('primary_contact_email')?.hasError('required')
              ">
              {{ "EMAIL_REQUIRED" | translate }}
            </mat-error>
            <mat-error *ngIf="userBForm.get('primary_contact_email')?.hasError('email')">
              {{ "EMAIL_INVALID" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label>{{ "MOBILE" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="primary_contact_phone" required />
            <mat-error *ngIf="
                userBForm.get('primary_contact_phone')?.hasError('required')
              ">
              {{ "MOBILE_REQUIRED" | translate }}
            </mat-error>
            <mat-error *ngIf="
                userBForm.get('primary_contact_phone')?.hasError('pattern')
              ">
              {{ "MOBILE_PATTERN" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>Role</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="companyName" required />
          </mat-form-field>
        </div>
      </div>
      <div class="form-actions flex gap-4">
        <button mat-raised-button color="primary" (click)="addEmp()">
          Add Employee
        </button>

        <button mat-raised-button color="primary" (click)="addEmpImp()">
          Import Employee
        </button>
      </div>
    </form>
    <div *ngIf="org_emp">
      <form [formGroup]="empForm" class="bg-white shadow rounded">
        <div class="flex flex-row gap-4">
          <div class="half-width">
            <mat-label>Company Name</mat-label>
            <mat-form-field appearance="outline" class="half-width">
              <input matInput formControlName="companyName" required />
              <mat-error *ngIf="empForm.get('companyName')?.hasError('required')">Required</mat-error>
            </mat-form-field>
          </div>
          <div class="half-width">
            <mat-label>Company ID</mat-label>
            <mat-form-field appearance="outline" class="half-width">
              <input matInput formControlName="companyId" />
              <mat-error *ngIf="empForm.get('companyId')?.hasError('pattern')">Alphanumeric only</mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="flex flex-row gap-4">
          <div class="half-width">
            <mat-label>Employee ID</mat-label>
            <mat-form-field appearance="outline" class="half-width">
              <input matInput formControlName="employeeId" />
              <mat-error *ngIf="empForm.get('employeeId')?.hasError('pattern')">Alphanumeric only</mat-error>
            </mat-form-field>
          </div>
          <div class="half-width">
            <mat-label>First Name</mat-label>
            <mat-form-field appearance="outline" class="half-width">
              <input matInput formControlName="fullName" placeholder="e.g., John Doe" />
              <mat-hint align="end">{{ empForm.get("fullName")?.value?.length || 0 }}/100</mat-hint>
            </mat-form-field>
          </div>
        </div>
        <div class="flex flex-row gap-4">
          <div class="half-width">
            <mat-label>Last Name</mat-label>

            <mat-form-field appearance="outline" class="half-width">
              <input matInput formControlName="fullName" placeholder="e.g., John Doe" />
              <mat-hint align="end">{{ empForm.get("fullName")?.value?.length || 0 }}/100</mat-hint>
            </mat-form-field>
          </div>
          <div class="half-width">
            <mat-label>Email</mat-label>

            <mat-form-field appearance="outline" class="half-width">
              <input matInput type="email" formControlName="email" />
              <mat-error *ngIf="empForm.get('email')?.hasError('email')">Invalid email</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="flex flex-row gap-4">
          <div class="half-width">
            <mat-label>Phone</mat-label>

            <mat-form-field appearance="outline" class="half-width">
              <input matInput formControlName="phone" placeholder="+[Country]-[XXX]-[XXX]-[XXXX]" />
            </mat-form-field>
          </div>
          <div class="half-width">
            <mat-label>Job Role</mat-label>

            <mat-form-field appearance="outline" class="half-width">
              <mat-select formControlName="jobRole">
                <mat-option *ngFor="let role of jobRoles" [value]="role">{{
                  role
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="flex flex-row gap-4">
          <div class="half-width">
            <mat-label>Designation</mat-label>

            <mat-form-field appearance="outline" class="half-width">
              <input matInput formControlName="designation" />
            </mat-form-field>
          </div>
          <div class="half-width">
            <mat-label>Hire Date</mat-label>

            <mat-form-field appearance="outline" class="half-width">
              <input matInput [matDatepicker]="picker1" formControlName="hireDate" />
              <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <div class="flex flex-row gap-4">
          <div class="half-width">
            <mat-label>End Date</mat-label>

            <mat-form-field appearance="outline" class="half-width">
              <input matInput [matDatepicker]="picker2" formControlName="endDate" />
              <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="half-width">
            <mat-checkbox formControlName="safetyTraining">Safety Training Completed</mat-checkbox>
          </div>
        </div>
        <div class="flex flex-row gap-4">
          <div class="half-width">
            <mat-label>Pincode</mat-label>

            <mat-form-field appearance="outline" class="half-width">
              <input matInput formControlName="pincode" />
            </mat-form-field>
          </div>
          <div class="half-width">
            <mat-label>Emergency Contact</mat-label>

            <mat-form-field appearance="outline" class="half-width">
              <input matInput formControlName="emergencyContact" />
            </mat-form-field>
          </div>
        </div>
        <div class="flex flex-row gap-4">
          <div class="half-width">
            <mat-label>Role</mat-label>

            <mat-form-field appearance="outline" class="half-width">
              <mat-select formControlName="role">
                <mat-option *ngFor="let type of accessTypes" [value]="type">{{
                  type
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="half-width">
            <mat-label>Subscription Start Date</mat-label>

            <mat-form-field appearance="outline" class="half-width">
              <input matInput [matDatepicker]="picker3" formControlName="subscriptionStart" />
              <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
              <mat-datepicker #picker3></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="half-width">
            <mat-label>Subscription End Date</mat-label>

            <mat-form-field appearance="outline" class="half-width">
              <input matInput [matDatepicker]="picker4" formControlName="subscriptionEnd" />
              <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
              <mat-datepicker #picker4></mat-datepicker>
            </mat-form-field>
          </div>
        </div>

        <div class="col-span-2 flex gap-4 mt-4">
          <button mat-raised-button color="primary" type="submit">
            Add Employee
          </button>
        </div>
      </form>
    </div>
    <div *ngIf="org_emp_imp">
      <div class="bg-white rounded-lg py-3 mb-6">
        <div class="toolbar">
          <input type="file" (change)="onFileChange($event)" accept=".xlsx, .xls" />
          <app-primary-button *ngIf="rowData.length != 0" (click)="saveChanges()"
            style="color: #1338de">Save</app-primary-button>
        </div>
        <div class="grid-wrapper" *ngIf="rowData.length != 0">
          <ag-grid-angular class="ag-theme-alpine custom-grid" style="width: 100%; height: 500px" [rowData]="rowData"
            [columnDefs]="columnDefs" [defaultColDef]="defaultColDef"></ag-grid-angular>
        </div>
        <app-empty-data *ngIf="rowData.length < 1" class="justify-center align-items-center"
          [imageSource]="'../../assets/blankScreen/support.png'" [message]="'No data available'"></app-empty-data>
      </div>
    </div>
    <div class="form-actions" style="float: right">
      <button mat-button matStepperPrevious>{{ "BACK" | translate }}</button>
      <button mat-raised-button color="primary" matStepperNext [disabled]="!userBForm.valid">
        {{ "NEXT" | translate }}
      </button>
    </div>
  </mat-step>
  <mat-step [stepControl]="userEForm">
    <form [formGroup]="userEForm">
      <ng-template matStepLabel>{{ "BRANCH" | translate }}</ng-template>

      <div formArrayName="additionalBranch">
        <div *ngFor="let branch of additionalBranch.controls; let i = index" [formGroupName]="i">
          <div class="flex flex-row gap-4">
            <div class="half-width">
              <mat-label>{{ "NAME" | translate }}</mat-label>
              <mat-form-field appearance="outline" class="half-width">
                <input matInput formControlName="primary_contact_name" required />
                <mat-error *ngIf="
                    branch.get('primary_contact_name')?.hasError('required')
                  ">
                  {{ "NAME_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="half-width">
              <mat-label>{{ "EMAIL" | translate }}</mat-label>
              <mat-form-field appearance="outline" class="half-width">
                <input matInput formControlName="primary_contact_email" required />
                <mat-error *ngIf="
                    branch.get('primary_contact_email')?.hasError('required')
                  ">
                  {{ "EMAIL_REQUIRED" | translate }}
                </mat-error>
                <mat-error *ngIf="branch.get('primary_contact_email')?.hasError('email')">
                  {{ "EMAIL_INVALID" | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="half-width">
              <mat-label>{{ "MOBILE" | translate }}</mat-label>
              <mat-form-field appearance="outline" class="half-width">
                <input matInput formControlName="primary_contact_phone" required />
                <mat-error *ngIf="
                    branch.get('primary_contact_phone')?.hasError('required')
                  ">
                  {{ "MOBILE_REQUIRED" | translate }}
                </mat-error>
                <mat-error *ngIf="
                    branch.get('primary_contact_phone')?.hasError('pattern')
                  ">
                  {{ "MOBILE_PATTERN" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="flex flex-row gap-4">
            <div class="half-width">
              <mat-label>{{ "BRANCH_NAME" | translate }}</mat-label>
              <mat-form-field appearance="outline">
                <input matInput formControlName="branch_name" />
                <mat-error *ngIf="branch.get('branch_name')?.hasError('required')">
                  {{ "BRANCH_NAME_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="half-width">
              <mat-label>{{ "COUNTRY" | translate }}</mat-label>
              <mat-form-field appearance="outline" class="half-width">
                <mat-select formControlName="country" (selectionChange)="onCountryBChange(i)" required>
                  <mat-option value="">{{
                    "SELECT_COUNTRY" | translate
                    }}</mat-option>
                  <mat-option value="India">India</mat-option>
                </mat-select>
                <mat-error *ngIf="branch.get('country')?.hasError('required')">
                  {{ "COUNTRY_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="flex flex-row gap-4">
            <div class="half-width">
              <mat-label>{{ "STATE" | translate }}</mat-label>
              <mat-form-field appearance="outline" class="half-width">
                <mat-select formControlName="state" (selectionChange)="onStateBChange(i)" required>
                  <mat-option value="">{{
                    "SELECT_STATE" | translate
                    }}</mat-option>
                  <mat-option *ngFor="let state of availableStates[i]" [value]="state">{{ state }}</mat-option>
                </mat-select>
                <mat-error *ngIf="branch.get('state')?.hasError('required')">
                  {{ "STATE_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="half-width">
              <mat-label>{{ "CITY" | translate }}</mat-label>
              <mat-form-field appearance="outline" class="half-width">
                <mat-select formControlName="city" required>
                  <mat-option value="">{{
                    "SELECT_CITY" | translate
                    }}</mat-option>
                  <mat-option *ngFor="let city of availableCities[i]" [value]="city">{{ city }}</mat-option>
                </mat-select>
                <mat-error *ngIf="branch.get('city')?.hasError('required')">
                  {{ "CITY_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="half-width">
              <mat-label>{{ "employee.postal_code" | translate }}</mat-label>
              <mat-form-field appearance="outline">
                <input matInput formControlName="postal_code" />
                <mat-error *ngIf="branch.get('postal_code')?.hasError('required')">
                  {{ "PINCODE_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <button mat-stroked-button type="button" (click)="openPicker(i, branch)">
            {{ "locateOnMap" | translate }}
          </button>
          <div class="flex flex-row gap-4">
            <div class="half-width">
              <mat-label>{{ "LAT" | translate }}</mat-label>
              <mat-form-field appearance="outline">
                <input matInput formControlName="lat" />
                <mat-error *ngIf="branch.get('lat')?.hasError('required')">
                  {{ "LAT_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="half-width">
              <mat-label>{{ "LONG" | translate }}</mat-label>
              <mat-form-field appearance="outline">
                <input matInput formControlName="long" />
                <mat-error *ngIf="branch.get('long')?.hasError('required')">
                  {{ "LONG_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="form-actions flex gap-4">
            <button mat-raised-button color="warn" *ngIf="additionalBranch.length > 1" (click)="removeBranch(i)"
              [disabled]="additionalBranch.length === 1">
              {{ "REMOVE" | translate }}
            </button>
            <button mat-raised-button color="primary" type="button" (click)="addBranch()">
              {{ "ADD_BRANCH" | translate }}
            </button>
          </div>
        </div>
      </div>
    </form>
    <div *ngIf="org_emp">
      <form [formGroup]="empForm" class="bg-white shadow rounded">
        <div class="flex flex-row gap-4">
          <div class="half-width">
            <mat-label>Company Name</mat-label>
            <mat-form-field appearance="outline" class="half-width">
              <input matInput formControlName="companyName" required />
              <mat-error *ngIf="empForm.get('companyName')?.hasError('required')">Required</mat-error>
            </mat-form-field>
          </div>
          <div class="half-width">
            <mat-label>Company ID</mat-label>
            <mat-form-field appearance="outline" class="half-width">
              <input matInput formControlName="companyId" />
              <mat-error *ngIf="empForm.get('companyId')?.hasError('pattern')">Alphanumeric only</mat-error>
            </mat-form-field>
          </div>
        </div>
          <div class="flex flex-row gap-4">
          <div class="half-width">
            <mat-label>Branch Name</mat-label>
            <mat-form-field appearance="outline" class="half-width">
              <input matInput formControlName="companyName" required />
              <mat-error *ngIf="empForm.get('companyName')?.hasError('required')">Required</mat-error>
            </mat-form-field>
          </div>
          <div class="half-width">
            <mat-label>Branch ID</mat-label>
            <mat-form-field appearance="outline" class="half-width">
              <input matInput formControlName="companyId" />
              <mat-error *ngIf="empForm.get('companyId')?.hasError('pattern')">Alphanumeric only</mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="flex flex-row gap-4">
          <div class="half-width">
            <mat-label>Employee ID</mat-label>
            <mat-form-field appearance="outline" class="half-width">
              <input matInput formControlName="employeeId" />
              <mat-error *ngIf="empForm.get('employeeId')?.hasError('pattern')">Alphanumeric only</mat-error>
            </mat-form-field>
          </div>
          <div class="half-width">
            <mat-label>First Name</mat-label>
            <mat-form-field appearance="outline" class="half-width">
              <input matInput formControlName="fullName" placeholder="e.g., John Doe" />
              <mat-hint align="end">{{ empForm.get("fullName")?.value?.length || 0 }}/100</mat-hint>
            </mat-form-field>
          </div>
        </div>
        <div class="flex flex-row gap-4">
          <div class="half-width">
            <mat-label>Last Name</mat-label>

            <mat-form-field appearance="outline" class="half-width">
              <input matInput formControlName="fullName" placeholder="e.g., John Doe" />
              <mat-hint align="end">{{ empForm.get("fullName")?.value?.length || 0 }}/100</mat-hint>
            </mat-form-field>
          </div>
          <div class="half-width">
            <mat-label>Email</mat-label>

            <mat-form-field appearance="outline" class="half-width">
              <input matInput type="email" formControlName="email" />
              <mat-error *ngIf="empForm.get('email')?.hasError('email')">Invalid email</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="flex flex-row gap-4">
          <div class="half-width">
            <mat-label>Phone</mat-label>

            <mat-form-field appearance="outline" class="half-width">
              <input matInput formControlName="phone" placeholder="+[Country]-[XXX]-[XXX]-[XXXX]" />
            </mat-form-field>
          </div>
          <div class="half-width">
            <mat-label>Job Role</mat-label>

            <mat-form-field appearance="outline" class="half-width">
              <mat-select formControlName="jobRole">
                <mat-option *ngFor="let role of jobRoles" [value]="role">{{
                  role
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="flex flex-row gap-4">
          <div class="half-width">
            <mat-label>Designation</mat-label>

            <mat-form-field appearance="outline" class="half-width">
              <input matInput formControlName="designation" />
            </mat-form-field>
          </div>
          <div class="half-width">
            <mat-label>Hire Date</mat-label>

            <mat-form-field appearance="outline" class="half-width">
              <input matInput [matDatepicker]="picker1" formControlName="hireDate" />
              <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <div class="flex flex-row gap-4">
          <div class="half-width">
            <mat-label>End Date</mat-label>

            <mat-form-field appearance="outline" class="half-width">
              <input matInput [matDatepicker]="picker2" formControlName="endDate" />
              <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="half-width">
            <mat-checkbox formControlName="safetyTraining">Safety Training Completed</mat-checkbox>
          </div>
        </div>
        <div class="flex flex-row gap-4">
          <div class="half-width">
            <mat-label>Pincode</mat-label>

            <mat-form-field appearance="outline" class="half-width">
              <input matInput formControlName="pincode" />
            </mat-form-field>
          </div>
          <div class="half-width">
            <mat-label>Emergency Contact</mat-label>

            <mat-form-field appearance="outline" class="half-width">
              <input matInput formControlName="emergencyContact" />
            </mat-form-field>
          </div>
        </div>
        <div class="flex flex-row gap-4">
          <div class="half-width">
            <mat-label>Role</mat-label>

            <mat-form-field appearance="outline" class="half-width">
              <mat-select formControlName="role">
                <mat-option *ngFor="let type of accessTypes" [value]="type">{{
                  type
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="half-width">
            <mat-label>Subscription Start Date</mat-label>

            <mat-form-field appearance="outline" class="half-width">
              <input matInput [matDatepicker]="picker3" formControlName="subscriptionStart" />
              <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
              <mat-datepicker #picker3></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="half-width">
            <mat-label>Subscription End Date</mat-label>

            <mat-form-field appearance="outline" class="half-width">
              <input matInput [matDatepicker]="picker4" formControlName="subscriptionEnd" />
              <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
              <mat-datepicker #picker4></mat-datepicker>
            </mat-form-field>
          </div>
        </div>

        <div class="col-span-2 flex gap-4 mt-4">
          <button mat-raised-button color="primary" type="submit">
            Add Employee
          </button>
        </div>
      </form>
    </div>
    <div *ngIf="org_emp_imp">
      <div class="bg-white rounded-lg py-3 mb-6">
        <div class="toolbar">
          <input type="file" (change)="onFileChange($event)" accept=".xlsx, .xls" />
          <app-primary-button *ngIf="rowData.length != 0" (click)="saveChanges()"
            style="color: #1338de">Save</app-primary-button>
        </div>
        <div class="grid-wrapper" *ngIf="rowData.length != 0">
          <ag-grid-angular class="ag-theme-alpine custom-grid" style="width: 100%; height: 500px" [rowData]="rowData"
            [columnDefs]="columnDefs" [defaultColDef]="defaultColDef"></ag-grid-angular>
        </div>
        <app-empty-data *ngIf="rowData.length < 1" class="justify-center align-items-center"
          [imageSource]="'../../assets/blankScreen/support.png'" [message]="'No data available'"></app-empty-data>
      </div>
    </div>
    <div class="form-actions flex gap-4" style="float: right">
      <button mat-button matStepperPrevious>{{ "BACK" | translate }}</button>

      <button mat-raised-button color="primary" (click)="addEmp()">
        Add Employee
      </button>

      <button mat-raised-button color="primary" (click)="addEmpImp()">
        Import Employee
      </button>
      <button mat-raised-button color="primary" matStepperNext [disabled]="!userEForm.valid">
        {{ "NEXT" | translate }}
      </button>
      <button *ngIf="roleName == 'Admin'" mat-raised-button color="primary" [disabled]="!userEForm.valid"
        (click)="onSubmit()">
        {{ "SUBMIT" | translate }}
      </button>
    </div>
  </mat-step>
  <mat-step materialsForm [stepControl]="materialsForm">
    <form [formGroup]="materialsForm">
      <ng-template matStepLabel>Materials</ng-template>
      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label>Company Name</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="companyName" required />
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>Company ID</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="companyId" />
          </mat-form-field>
        </div>
      </div>
      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label>Branch Name</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="branchName" required />
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>Branch ID</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="branchId" />
          </mat-form-field>
        </div>
      </div>
      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label>Material Name</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="materialName" required />
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>Category</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="category" />
          </mat-form-field>
        </div>
      </div>
      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label>Subcategory</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="subcategory" required />
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>Manufacturer</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="manufacturer" />
          </mat-form-field>
        </div>
      </div>
      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label>Code</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="code" required />
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>Region</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="region" />
          </mat-form-field>
        </div>
      </div>
      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label>Strength</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="strength" required />
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>Density</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="density" />
          </mat-form-field>
        </div>
      </div>
      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label>Length</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="length" required />
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>Width</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="width" />
          </mat-form-field>
        </div>
      </div>
      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label>Thickness</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="thickness" required />
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>Unit</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="unit" />
          </mat-form-field>
        </div>
      </div>
      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label>Quantity</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="quantity" required />
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>UnitCost</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="unitCost" />
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>TotalCost</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="totalCost" />
          </mat-form-field>
        </div>
      </div>
      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label>Name</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="name" required />
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>Location</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="location" />
          </mat-form-field>
        </div>
      </div>
      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label>LeadTime</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="leadTime" required />
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>CarbonFootprint</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="carbonFootprint" />
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>Recyclability</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="recyclability" />
          </mat-form-field>
        </div>
      </div>
      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label>BuildingType</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="buildingType" required />
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>UseCase</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="useCase" />
          </mat-form-field>
        </div>
      </div>
      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label>Certifications</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="certifications" required />
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>Testing Method</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="testingMethod" />
          </mat-form-field>
        </div>
      </div>
      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label>Tools</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="tools" required />
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>Method</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="method" />
          </mat-form-field>
        </div>
      </div>
      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label>Countries</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="countries" required />
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>Regions</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="regions" />
          </mat-form-field>
        </div>
      </div>
      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label>Durability</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="durability" required />
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>FireResistance</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="fireResistance" />
          </mat-form-field>
        </div>
      </div>
      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label>Brand</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="brand" required />
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>Model</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="model" />
          </mat-form-field>
        </div>
      </div>
    </form>
  </mat-step>
  <mat-step userDForm [stepControl]="userDForm" *ngIf="roleName == 'Admin'">
    <form [formGroup]="userDForm" class="w-full">
      <ng-template matStepLabel>{{ "BASIC" | translate }}</ng-template>

      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label>{{ "MEMBERSHIP_START_DATE" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput [matDatepicker]="startPicker" formControlName="membership_start_date" />
            <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
            <mat-error *ngIf="
                userDForm.get('membership_start_date')?.hasError('required')
              ">
              {{ "START_DATE_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="half-width">
          <mat-label>{{ "MEMBERSHIP_END_DATE" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput [matDatepicker]="endPicker" formControlName="membership_end_date" />
            <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
            <mat-error *ngIf="userDForm.get('membership_end_date')?.hasError('required')">
              {{ "END_DATE_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="flex flex-row gap-4">
        <div class="half-width">
          <mat-label>{{ "ONBOARDING_DATE" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput [matDatepicker]="picker" formControlName="onboarding_date" />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error *ngIf="userDForm.get('onboarding_date')?.hasError('required')">
              {{ "ONBOARDING_DATE_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="half-width">
          <mat-label>{{ "STATUS" | translate }}</mat-label><br />
          <mat-slide-toggle formControlName="status" color="primary">
            {{
            userDForm.get("status")?.value
            ? ("ACTIVE" | translate)
            : ("INACTIVE" | translate)
            }}
          </mat-slide-toggle>
        </div>
      </div>

      <div class="form-actions">
        <button mat-button matStepperPrevious>{{ "BACK" | translate }}</button>
        <button mat-raised-button color="primary" matStepperNext [disabled]="!userDForm.valid" (click)="onSubmit()">
          {{ "SUBMIT" | translate }}
        </button>
      </div>
    </form>
  </mat-step>
</mat-horizontal-stepper>